import React, { useEffect, useMemo, useState } from 'react';
import { ModalFooter } from '@Components/ModalComponents';
import { ConnectDeptStep } from './ConnectDeptStep';
import { IkeOfficeLoginStep } from './IkeOfficeLoginStep';

enum ConnectDepartmentPage {
    LOGIN,
    CONNECT_DEPT,
}

interface IConnectDeptDialogueProps {
    teamId: string;
    projectId: number;
    onCancel: () => void;
    onComplete: () => void;
    setCancelDisabled: (disabled: boolean) => void;
    setFooter: (footer: JSX.Element) => void;
}

export const ConnectDepartmentDialog = (props: IConnectDeptDialogueProps) => {
    const [currentPage, setCurrentPage] = useState<ConnectDepartmentPage>(
        ConnectDepartmentPage.LOGIN
    );

    const innerHtml = useMemo(() => {
        return currentPage === ConnectDepartmentPage.LOGIN ? (
            <IkeOfficeLoginStep
                setFooter={props.setFooter}
                onCancel={props.onCancel}
                onLoggedIn={() =>
                    setCurrentPage(ConnectDepartmentPage.CONNECT_DEPT)
                }
                setCancelDisabled={props.setCancelDisabled}
            />
        ) : (
            <ConnectDeptStep {...props} />
        );
    }, [currentPage]);

    return <React.Fragment>{innerHtml}</React.Fragment>;
};
